import React from 'react';
import { openEventModal, openEliteBuyerModal } from '../../utils/functions';

const EventsSection = () => {
  return (
    <section id="events" className="events-section">
      <div className="container">
        <div className="section-header">
          <h2>Events & Meetups</h2>
          <p>Join us for networking and business opportunities</p>
        </div>
        
        <div className="events-grid">
          <div id="synergy-meet" className="event-card">
            <div className="event-icon">
              <i className="fas fa-network-wired"></i>
            </div>
            <h3>Synergy Meet West Zone</h3>
            <p className="event-subtitle">Exclusive gathering of all BSB ecosystem stakeholders</p>
            <div className="event-description">
              <div className="event-highlights">
                <div className="highlight-item">
                  <i className="fas fa-check-circle"></i>
                  <span>Focus on onboarding, collaboration, and long-term partnership alignment.</span>
                </div>
                <div className="highlight-item">
                  <i className="fas fa-check-circle"></i>
                  <span>Vision sharing on BSB's integrated platform and future roadmap.</span>
                </div>
                <div className="highlight-item">
                  <i className="fas fa-check-circle"></i>
                  <span>Discussion on operational benefits, revenue opportunities, and growth potential for each stakeholder.</span>
                </div>
                <div className="highlight-item">
                  <i className="fas fa-check-circle"></i>
                  <span>Platform to strengthen network, streamline processes, and build multi-module synergy.</span>
                </div>
              </div>
            </div>
            <button className="btn btn-primary" onClick={() => openEventModal('synergy-meet')}>
              Register Now
            </button>
          </div>
          
          <div id="elite-buyer" className="event-card">
            <div className="event-icon">
              <i className="fas fa-star"></i>
            </div>
            <h3>Elite Buyer Club</h3>
            <p className="event-subtitle">Specialized buyer groups for competitive advantages</p>
            <div className="event-description">
              <div className="event-highlights">
                <div className="highlight-item">
                  <i className="fas fa-check-circle"></i>
                  <span>Formation of specialized buyer groups with similar polymer grade requirements (domestic or import).</span>
                </div>
                <div className="highlight-item">
                  <i className="fas fa-check-circle"></i>
                  <span>Club-based procurement strategy enabling bulk negotiation with suppliers, logistics operators, and other stakeholders.</span>
                </div>
                <div className="highlight-item">
                  <i className="fas fa-check-circle"></i>
                  <span>Members gain competitive pricing, priority access, and better deal visibility.</span>
                </div>
                <div className="highlight-item">
                  <i className="fas fa-check-circle"></i>
                  <span>Supports collective decision-making and cost optimization for high-volume buyers.</span>
                </div>
                <div className="highlight-item">
                  <i className="fas fa-check-circle"></i>
                  <span>Exclusive club benefits, early insights, and strategic buying advantages for registered members.</span>
                </div>
              </div>
            </div>
            <button className="btn btn-primary" onClick={openEliteBuyerModal}>
              Join Elite Buyer Club
            </button>
          </div>
          
          <div id="channel-partner" className="event-card">
            <div className="event-icon">
              <i className="fas fa-users"></i>
            </div>
            <h3>Channel Partner Meet</h3>
            <p className="event-subtitle">Onboard buyers across industries</p>
            <div className="event-description">
              <div className="event-highlights">
                <div className="highlight-item">
                  <i className="fas fa-check-circle"></i>
                  <span>Interaction with experienced channel partners having strong domain knowledge.</span>
                </div>
                <div className="highlight-item">
                  <i className="fas fa-check-circle"></i>
                  <span>Explanation of buying advantages, pricing support, logistics, and credit facilities offered by BSB.</span>
                </div>
                <div className="highlight-item">
                  <i className="fas fa-check-circle"></i>
                  <span>Territory-wise channel partner onboarding to strengthen local presence and market penetration.</span>
                </div>
                <div className="highlight-item">
                  <i className="fas fa-check-circle"></i>
                  <span>Training on BSB's digital platform for seamless buying and deal execution.</span>
                </div>
              </div>
            </div>
            <button 
              className="btn btn-primary" 
              onClick={() => window.open('https://channelpartner.bsbfortrade.com', '_blank')}
            >
              Visit Channel Partner Portal <i className="fas fa-external-link-alt"></i>
            </button>
          </div>
          
          <div id="supplier-meet" className="event-card">
            <div className="event-icon">
              <i className="fas fa-building"></i>
            </div>
            <h3>Supplier Meet</h3>
            <p className="event-subtitle">Specialized buyer groups for bulk procurement</p>
            <div className="event-description">
              <div className="event-highlights">
                <div className="highlight-item">
                  <i className="fas fa-check-circle"></i>
                  <span>Formation of specialized buyer groups with similar polymer grade requirements (domestic or import).</span>
                </div>
                <div className="highlight-item">
                  <i className="fas fa-check-circle"></i>
                  <span>Club-based procurement strategy enabling bulk negotiation with suppliers, logistics operators, and other stakeholders.</span>
                </div>
                <div className="highlight-item">
                  <i className="fas fa-check-circle"></i>
                  <span>Members gain competitive pricing, priority access, and better deal visibility.</span>
                </div>
                <div className="highlight-item">
                  <i className="fas fa-check-circle"></i>
                  <span>Supports collective decision-making and cost optimization for high-volume buyers.</span>
                </div>
                <div className="highlight-item">
                  <i className="fas fa-check-circle"></i>
                  <span>Exclusive club benefits, early insights, and strategic buying advantages for registered members.</span>
                </div>
              </div>
            </div>
            <button 
              className="btn btn-primary" 
              onClick={() => window.open('https://supplier.bsbfortrade.com', '_blank')}
            >
              Visit Supplier Portal <i className="fas fa-external-link-alt"></i>
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default EventsSection;

